<template>
  <div class="kudos__leaderboard content-wrap mt--4">
    <div class="container">
      <div class="filters">
        <label>Filter by date</label>
        <v-select
          v-if="dateOptions.length"
          v-model="filters.date"
          @input="filterByDate"
          :options="dateOptions"
          class="mb--2"
        />
        <label>Filter by type</label>
        <v-select
          v-if="kudosTypeOptions.length"
          v-model="filters.type"
          @input="filterByType"
          :options="kudosTypeOptions"
          class="mb--4"
        />
      </div>
      <table class="mdl-data-table mdl-js-data-table mdl-shadow--2dp">
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Kudos</th>
          </tr>
        </thead>
        <tbody v-if="receivers.length">
          <tr v-for="(receiver, key) in receivers" :key="key">
            <td class="mdl-data-table__cell--non-numeric">{{ key + 1}}</td>
            <td>{{ `${receiver.forename} ${receiver.surname}` }}</td>
            <td>{{ receiver.total_kudos }}</td>
          </tr>
        </tbody>
      </table>
      <div class="filters d--flex justify-content--center mt--4">
        <router-link to="/kudos" tag="button" id="back-to-kudos-button" :class="`btn ${theme}-bg`">Back to Kudos</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import axios from 'axios'

export default {
  name: 'kudos-leaderboard',
  props: {
    clientId: {
      type: String,
      required: true
    },
    theme: {
      type: String,
      required: false,
      default: 'primary'
    }
  },
  components: {
    vSelect
  },
  data: () => ({
    receivers: [],
    showAddModal: false,
    activeReceiver: null,
    filters: {
      date: 'All time',
      type: 'All types'
    },
    dateOptions: [
      { label: 'All time', code: 'all_time' },
      { label: 'This week', code: 'week' },
      { label: 'This month', code: 'month' },
      { label: 'This year', code: 'year' }
    ],
    kudosTypeOptions: [
      { label: 'All types', code: 'all_types' }
    ]
  }),
  methods: {
    getLeaderboard (options) {
      let params = {
        clientId: this.clientId,
        leaderboard: true,
        ...options
      }
      axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos`, { params: params })
        .then(response => {
          this.receivers = response.data
        })
    },
    filterByType (value) {
      this.getLeaderboard({ type: value.code })
    },
    filterByDate (value) {
      let startDate = null 
      let endDate = null
      let today = new Date()

      switch(value.code) {
        case 'week':
          var first = today.getDate() - today.getDay() + 1
          var last = first + 6
          startDate = this.formatDate(today.setDate(first))
          endDate = this.formatDate(today.setDate(last))
          break
        case 'month':
          startDate = new Date(today.getFullYear(), today.getMonth(), 1)
          endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0)
          break
        case 'year':
          startDate = new Date(new Date().getFullYear(), 0, 1)
          endDate = today
          break
        default:
          this.getLeaderboard()
          return 
      }

      let options = {
        startDate,
        endDate
      }

      this.getLeaderboard(options)
    },
    formatDate(date) {
			let d = new Date(date)
			let month = d.getMonth() + 1
			let day = d.getDate()

			day = day < 10 ? `0${day}` : day
			month = month < 10 ? `0${month}` : month

			return `${d.getFullYear()}-${month}-${day}`
		},
    toggleModal (receiver) {
      this.activeReceiver = receiver
      this.showAddModal = true
    }
  },
  mounted () {
    this.getLeaderboard()
    axios.get(`https://abx8y1kjk2.execute-api.eu-west-2.amazonaws.com/production/kudos-types?clientId=${this.clientId}`)
      .then(response => {
        response.data.forEach(type => {
          this.kudosTypeOptions.push({
            label: type.title,
            code: type.id 
          })
        })
      })
  }
}
</script>

<style lang="scss" scoped>
  @import '../scss/kudos';
</style>